<app-template-preview previewMode="inline" [inlinePreview]="preview" [control]="control" [value]="value" [disabled]="disabled" (preview)="setBarcode($event)">{{
  "FORM.THREATS.BOOL.BAR"
}}</app-template-preview>
